<template>
  <div class="page">
    <!-- 顶部 Logo 与主题 -->
		<div class="logo">
			<img src="../assets/images/logo.png" alt="" />
		</div>
		<div class="theme-logo"></div>
		<div class="sub-logo"></div>

    <!-- 邀请函标题（使用图片） -->
    <div class="invite-title">
      <img
        src="../assets/images/invitation.png"
        alt="邀请函 INVITATION"
        class="invite-image"
      />
    </div>

    <!-- 二维码卡片 -->
    <div class="qr-card">
      <div class="qr-inner">
        <img src="../assets/images/qr_code.jpg" alt="报名二维码" class="qr-image" />
      </div>
      <div class="qr-text">扫码报名</div>
    </div>

    <!-- 时间地点 -->
    <div class="footer-info">
      <div class="date">2026.3</div>
      <div class="place">湖北·武汉</div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.page {
  width: 100vw;
  min-height: 100vh;
  background: url("../assets/bg/background-3.jpg") 100% 100% no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 32px 20px 40px;
  color: #ffffff;
}

.logo-row {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.logo img {
	width: 40%;
    height: auto;
    display: block;
    padding: 20px 0 ;
    margin-left: 10%;
	padding-top: 10%;
}
.sub-logo {
	width: 90%;
	height: 30px;
	background: url("../assets/images/sub-logo.png") no-repeat center center;
	background-size: contain;
	margin: auto;
}
.theme-logo {
	width: 80%;
	height: 60px;
	background: url("../assets/images/theme.png") no-repeat center center;
	background-size: contain;
	margin: auto;
}

.main-title {
  margin-top: 40px;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 2px;
  text-align: center;
}

.sub-title {
  margin-top: 16px;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  font-size: 13px;
  text-align: center;
}

.invite-title {
  text-align: center;
}

.invite-image {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  margin-top: -60px;
}

.qr-card {
  margin-top: -60px;
  padding: 10px;
  background: url("../assets/images/border.png") no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-inner {
  padding: 4px;
}

.qr-image {
  width: 200px;
  height: 200px;
  object-fit: cover;
  display: block;
}

.qr-text {
  margin-top: 12px;
  font-size: 18px;
  letter-spacing: 4px;
}

.footer-info {
  margin-top: 32px;
  text-align: center;
  font-size: 14px;
}

.date {
  margin-bottom: 4px;
}
</style>

